
export class WizLocaleUtils {

  private static dateLocales: Set<string> = new Set([
    'af', 'ar-dz', 'ar-kw', 'ar-ly', 'ar-ma', 'ar-sa', 'ar-tn',
    'ar', 'az', 'be', 'bg', 'bm', 'bn', 'bo', 'br', 'bs', 'ca',
    'cs', 'cv', 'cy', 'da', 'de-at', 'de-ch', 'de', 'dv', 'el',
    'en', 'en-au', 'en-ca', 'en-gb', 'en-ie', 'en-il', 'en-nz', 'en-SG',
    'eo', 'es-do', 'es-us', 'es', 'et', 'eu', 'fa', 'fi', 'fo',
    'fr-ca', 'fr-ch', 'fr', 'fy', 'ga', 'gd', 'gl', 'gom-latn',
    'gu', 'he', 'hi', 'hr', 'hu', 'hy-am', 'id', 'is', 'it-ch',
    'it', 'ja', 'jv', 'ka', 'kk', 'km', 'kn', 'ko', 'ku', 'ky',
    'lb', 'lo', 'lt', 'lv', 'me', 'mi', 'mk', 'ml', 'mn', 'mr',
    'ms-my', 'ms', 'mt', 'my', 'nb', 'ne', 'nl-be', 'nl', 'nn',
    'pa-in', 'pl', 'pt-br', 'pt', 'ro', 'ru', 'sd', 'se', 'si',
    'sk', 'sl', 'sq', 'sr-cyrl', 'sr', 'ss', 'sv', 'sw', 'ta',
    'te', 'tet', 'tg', 'th', 'tl-ph', 'tlh', 'tr', 'tzl',
    'tzm-latn', 'tzm', 'ug-cn', 'uk', 'ur', 'uz-latn', 'uz', 'vi',
    'x-pseudo', 'yo', 'zh-cn', 'zh-hk', 'zh-tw']);

    /**
     * Returns date local according to application translation locale
     * @param pApplicationLocales Current application translation locales
     */
    public static getLocale(pApplicationLocales: string[]): string {
      let result: string;
      if (pApplicationLocales) {
        for (let i: number = 0; i < pApplicationLocales.length && !result; i++) {
          result = pApplicationLocales[i].toLowerCase();
          if (!this.dateLocales.has(result)) {
            result = null;
          }
        }
      }
      return result;
    }
}
